import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { barChartOptionsWeeklyRevenue } from "variables/charts";
import { TbArrowsMaximize } from "react-icons/tb";
import { Modal, Tooltip } from 'antd';
import React, { useState } from 'react';
import { urls } from "helpers/urls";
import { useFetch } from "hooks/useFetch";
import dayjs from 'dayjs';

const WeeklyRevenue = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const {data,loading} = useFetch({
    url: urls.logsCount,
    config:{
            start_date: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
    },
    onCompleted: (data) => {
      console.log(data);
      console.log(data?.data?.map((item) => ({
        x: dayjs(item.date).format('YYYY-MM-DD'),
        y: item.count
      })));
      return data?.data?.map((item) => ({
        x: dayjs(item.date).format('YYYY-MM-DD'),
        y: item.count
      }));
    },
  })


const barChartDataWeeklyRevenue = [
  {
    name: "Weekly Token ",
    data,
    color: "#2563eb",
  },
];

console.log(data)


  return (
    <Card extra="flex flex-col bg-white w-full py-6 px-2 text-center" style={{border:"1px solid #81aae780"}}>
      <div className="mb-auto flex items-center justify-between px-6 ">
        <h2 className="text-[24px] font-[600] text-[#000] dark:text-white" style={{ fontFamily: "figtree" }}>
          Weekly Utilization
        </h2>
        <button onClick={showModal} className="!linear flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-[#2369d2] !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
         <Tooltip title="Maximize the screen">
          <TbArrowsMaximize className="h-5 w-5" />
         </Tooltip>
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {!loading && <BarChart
            chartData={barChartDataWeeklyRevenue}
            chartOptions={barChartOptionsWeeklyRevenue}
          />}
        </div>
      </div>
       <Modal title="Weekly Utilization" open={isModalVisible} onCancel={handleCancel} footer={null} width="80vw">
        <div style={{ height: '70vh' }}>
        {!loading && <BarChart
            chartData={barChartDataWeeklyRevenue}
            chartOptions={barChartOptionsWeeklyRevenue}
          />}
        </div>
      </Modal>
    </Card>
  );
};

export default WeeklyRevenue;
